import { systemPermissions } from '@/constants/permissions';

export const NEW_TRANSACTIONS_VIEW = [systemPermissions.newTransactionsView];
export const ALL_TRANSACTIONS_VIEW = [
  systemPermissions.allTransactionsView,
  systemPermissions.allTransactionsDownload,
];
export const ALL_TRANSACTIONS_DOWNLOAD = [systemPermissions.allTransactionsDownload];
export const TOTALS_VIEW = [systemPermissions.totalsView];
export const SETTINGS_MODIFY = [systemPermissions.settingsModify];
export const QR_CODE_DOWNLOAD = [systemPermissions.qrCodeDownload];
export const SUPPORT_VIEW = [systemPermissions.supportView];
